import EditBackgroundPopover from './EditBackgroundPopover';

export default EditBackgroundPopover;
